module.exports = __webpack_public_path__ + "asset/image-iconCategoryPersonalCare-5616d6d8f13ba78f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/iconCategoryPersonalCare.svg
// module id = nrl3
// module chunks = 0